import { NetworkRepWithSource } from "../../../report_summary/@types";

const CLASSIFICATIONS_COUNTER = {
  malicious: 0,
  suspicious: 0,
  goodware: 0,
  unknown: 0
} as Record<string, number>;

export const getNetworkReferencesCounts = (data: Array<NetworkRepWithSource>) =>
  data.reduce(
    (acc, curr) => ({
      ...acc,
      [curr.classification]: acc[curr.classification] + 1
    }),
    CLASSIFICATIONS_COUNTER
  );

export const getNetworkReferencesCounts2 = (
  stats: Record<string, Record<string, number>>
) => {
  const { hasMoreData, total, ...rest } = stats;
  return Object.values(rest).reduce(
    (acc, curr) => ({
      malicious: acc.malicious + curr.malicious,
      suspicious: acc.suspicious + curr.suspicious,
      goodware: acc.goodware + curr.goodware,
      unknown: acc.unknown + curr.unknown
    }),
    CLASSIFICATIONS_COUNTER
  );
};

export const getTotalMalicious = (data: Array<NetworkRepWithSource>) =>
  data.reduce(
    (acc, curr) => (curr.classification === "malicious" ? acc + 1 : acc),
    0
  );
